import { useBoardContext } from '../../../hooks/use-board'
import React from 'react'
import { MemoizedSortableColumn } from './memoized-sortable-column'

export function DragOverlayColumn() {
    const { activeColumn, columns, dragTransform } = useBoardContext()

    if (!activeColumn) {
        return null
    }

    return (
        <div
            style={{
                opacity: 0.9,
                transform: dragTransform,
            }}
        >
            <MemoizedSortableColumn
                id={activeColumn?.columnId}
                title={columns[activeColumn?.columnId].column.name}
                isOver={false}
                dropLinePosition={null}
            />
        </div>
    )
}
